import { render, staticRenderFns } from "./ProductsDropdownContainer.vue?vue&type=template&id=5cea16f1&"
import script from "./ProductsDropdownContainer.vue?vue&type=script&lang=ts&"
export * from "./ProductsDropdownContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports